import React, { useContext, useState, useEffect } from 'react';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import { GMCContext } from '../../GMCContext';
import Copy from '../Common/Copy';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Pagination from '../Common/Pagination';


export default function Pool2() {
  const { togel, formatAddress, setTogel, isSidebarEnabled, setIsSidebarEnabled, formatDateTime } = useContext(GMCContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");


  // Fetch data function
  const getData = async () => {
    try {
      setLoading(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "preward",
        submethod: "get2",
        key: process.env.REACT_APP_KEY,
        search: search,
        page: currentPage,
        pageSize: pageSize,

      });

      setLoading(false);
      // console.log('res.data.data', res.data.data)
      if (res.data.error) return;
      setData(res.data.data);
      setPages(Math.ceil(res.data.total / pageSize));
    } catch (err) {
      console.log("Error : ", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [pageSize, currentPage, search]);

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1); // Reset to page 1 if currentPage is out of range
    }
  }, [pages]);
  return (
    <>
      <Header />
      <Sidebar />
      <div id="layout-wrapper">
        <div className="vertical-overlay" onClick={() => setIsSidebarEnabled((prev) => !prev)} />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* Page Title Section */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="javascript: void(0);">Tables</a></li>
                      <li className="breadcrumb-item active">Pool 2</li>
                    </ol>
                  </div>
                </div>
              </div>

              {/* Member Report Table Section */}
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Pool 2</h4>
                    </div>
                    <div className="card-body">
                      <div className="listjs-table" id="customerList">
                        {/* Table Action Buttons */}
                        <div className="row g-4 mb-3">
                          <div className="col-sm-auto">

                          </div>
                          <div className="col-sm">
                            <div className="d-flex justify-content-sm-end">
                              <div className="search-box ms-2">
                                <input
                                  type="text"
                                  className="form-control search"
                                  placeholder="Search..."
                                  onChange={(e) => setSearch(e.target.value)}
                                />
                                <i className="ri-search-line search-icon" />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Table */}
                        <div className="table-responsive table-card mt-3 mb-1">
                          <table className="table align-middle table-nowrap" id="customerTable">
                            <thead className="table-light">
                              <tr>
                                <th className="gridjs-th text-center">#</th>
                                <th className="gridjs-th text-center">From User </th>
                                <th className="gridjs-th text-center">To User</th>
                                <th className="gridjs-th text-center">Total Staking</th>
                                <th className="gridjs-th text-center">Level Reward</th>
                                <th className="gridjs-th text-center">Pool Reward</th>
                                <th className="gridjs-th text-center">Weely Reward</th>
                                <th className="gridjs-th text-center">Re-Stake Statu</th>
                                <th className="gridjs-th text-center">Status</th>
                                <th className="gridjs-th text-center">Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.length > 0 ? (
                                data.map((ele, i) => {
                                  const index = currentPage * pageSize - pageSize + (i + 1);
                                  return (
                                    <tr key={i}>
                                      <td className="gridjs-td text-center">{index} </td>
                                      <td className="gridjs-td text-center">
                                        <div>
                                          <a
                                            target="_blank"
                                            className="text-primary"
                                            href={`${process.env.REACT_APP_EXPLORER}/address/${ele.username}`}
                                            rel="noreferrer"
                                          >
                                            <span className="name-title">Address:</span> {ele.username}
                                          </a>
                                          <Copy data={ele.username} />
                                        </div>
                                        <div className="username-name">
                                          <span className="name-title">Name:</span> {ele.fromname || "-"}
                                          <Copy data={ele.fromname} />
                                        </div>
                                      </td>
                                      <td className="gridjs-td text-center">
                                        <div>
                                          <a
                                            target="_blank"
                                            className="text-primary"
                                            href={`${process.env.REACT_APP_EXPLORER}/address/${ele.ref_username}`}
                                            rel="noreferrer"
                                          >
                                            <span className="name-title">Address:</span>{ele.ref_username}
                                          </a>
                                          <Copy data={ele.ref_username} />
                                        </div>
                                        <div className="ref-name">
                                          <span className="name-title">Name:</span> {ele.toname || "-"}
                                          <Copy data={ele.toname} />
                                        </div>
                                      </td>
                                      <td className="gridjs-td text-center">${ele.totalstake || "0"}</td>
                                      <td className="gridjs-td text-center">${ele.level_rew || "0"}</td>
                                      <td className="gridjs-td text-center">${ele.pool_rew || "0"}</td>
                                      <td className="gridjs-td text-center">${parseFloat(ele.week_rew).toFixed(2) || "0"}</td>
                                      <td className="gridjs-td text-center">
                                        <span className={`badge ${ele.restake ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} text-uppercase`}>
                                          {ele.restake ? "Active" : "Deactive"}
                                        </span>
                                      </td>
                                      <td className="gridjs-td text-center">
                                        <span className={`badge ${ele.status ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} text-uppercase`}>
                                          {ele.status ? "Active" : "Deactive"}
                                        </span>
                                      </td>
                                      <td className="gridjs-td text-center">{formatDateTime(ele.date)}</td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan="11" className="text-center">
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        <Pagination
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          pageSize={pageSize}
                          setPageSize={setPageSize}
                          pages={pages}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}